import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
} from "@chakra-ui/react";
import { DemoVideo } from "../demo-video";

interface DemoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
  thumbnail?: string;
  title: string;
}

export const DemoModal: React.FC<DemoModalProps> = ({
  isOpen,
  onClose,
  videoUrl,
  thumbnail,
  title,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
      <ModalOverlay />
      <ModalContent
        maxW="600px"
        h={{
          base: "300px",
          md: "400px",
        }}
        p={{ base: 2 }}
        borderRadius="0"
      >
        <ModalCloseButton />
        <ModalBody>
          <DemoVideo
            videoUrl={videoUrl}
            thumbnail={thumbnail}
            title={title}
            className="w-full"
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DemoModal;
